import React from 'react';
import { MenuItem } from '@fiverr-private/dropdown';
import { Container } from '@fiverr-private/layout_components';

interface DropdownMenuItemProps {
    children: React.ReactNode;
    collectionId: string;
    onClick: (checked: boolean) => void;
    checked: boolean;
}

export const DropdownMenuItem = ({ children, collectionId, onClick, checked }: DropdownMenuItemProps) => (
    <MenuItem selectable value={collectionId} onClick={() => onClick(!checked)}>
        <Container display="flex" paddingRight="3" alignItems="center">
            {children}
        </Container>
    </MenuItem>
);
